function preparePlugins(container)
{

    if (typeof mvGallery !== 'undefined') {
        mvGallery.init('.mv-gallery');
    }

    if (typeof Swiper !== 'undefined') {
        new Swiper('.gallery-slider', {
            slidesPerView: 2,
            slidesPerGroup: 1,
            centeredSlides: true,
            spaceBetween: 20,
            loop: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            autoplay: {
                delay: 7500,
                disableOnInteraction: false
            },
        });
    }

    $(container).find('.token-field').each(function () {

        let tokenField = $(this);
        let params = {};
        let progress = tokenField.closest('.form-group').find('.input-group-append .fas');

        let hintingHandle = tokenField.data('hinting-handle');

        if (hintingHandle) {

            params.autocomplete = {};
            params.autocomplete.source = function (request, response) {

                let term = request.term;

                if (term.length) {

                    setTimeout(function () {
                        progress.removeClass('d-none');
                    }, 100);

                    $.nette.ajax({
                        url: hintingHandle,
                        dataType: "json",
                        data: {
                            term: request.term
                        },
                        success: function (payload) {
                            response(payload.data);
                            progress.addClass('d-none');
                        },
                        error: function (err) {
                            progress.addClass('d-none');
                        }
                    });

                }

            };
            params.autocomplete.delay = 20;
            params.showAutocompleteOnFocus = true;
        }

        params.limit = tokenField.data('max-tokens');
        params.minLength = tokenField.data('min-token-len');

        tokenField.tokenfield(params);

        if (hintingHandle) {
            tokenField.on('tokenfield:createtoken', function (e) {
                progress.addClass('d-none');
            });
        }

    });

    container.find('.lazy-hinting-field').each(function () {

        let field = $(this);

        field.autocomplete({
            source: function (request, response) {

                let progress = field.closest('.form-group').find('.input-group-append');
                progress.removeClass('d-none');

                $.nette.ajax({
                    url: field.data('hintingHandle'),
                    dataType: "json",
                    data: {
                        term: request.term
                    },
                    success: function (payload) {
                        response(payload.data);
                    },
                    complete: function () {
                        progress.addClass('d-none');
                    }
                });
            },
            minLength: field.data('min-len')
        });

        field.on('focus', function () {
            if ($(this).val() === "") {
                $(this).keydown();
            }
        });

    });

    if (isDefined($.fn.select2)) {
        $("select.select2").each(function (){
            if(!$(this).hasClass("no-autoinit")){
                $(this).select2();
            }
        });
    }

    if (typeof lazyLoadInstance !== 'undefined') {
        lazyLoadInstance.update();
    }

    $('.date-time-picker').each(function () {

        let elemId = '#' + $(this).attr('id');
        console.log(elemId);

        $(elemId).datepicker({
            uiLibrary: 'bootstrap4',
            modal: true,
            footer: true,
            format: 'd. m. yyyy',
            todayHighlight: true,
            language: 'fr',
            startDate: isDefined($(this).data('min-date')) ? moment($(this).data('min-date'), 'YYYY-MM-DD')
            .toDate() : null
        });

    });

}

function isNumber(n)
{
    return !isNaN(parseFloat(n)) && isFinite(n);
}

function formatMenus(option, allowSpaces = true)
{
    if (!option.id) {
        return option.text;
    }
    if (!isNumber(option.id)) {
        return '<strong>' + option.text + '</strong>';
    }
    var arr = option.text.split('###');
    var padding = parseInt(arr[0]) * 10;

    if (allowSpaces === false) {
        return arr[1];
    }
    return '<span style="padding-left: ' + padding + 'px">' + arr[1] + '<span>';
}

$(document).ready(function () {

    preparePlugins($(document));

    $.nette.init();

    $.nette.ext({
        complete: function (payload) {
            preparePlugins($(document));
        }
    });

    $('.menus').select2({
        templateResult: formatMenus,
        templateSelection: function (option) {
            return formatMenus(option, false);
        },
        escapeMarkup: function (m) {
            return m;
        }
    });

    $(document).on('click', '.link-page', function (e) {
        e.preventDefault();
        window.location.href = $(this).data('link');
    });

    $(document).on('click', '.nav .nav-icons a', function (e) {
        e.stopImmediatePropagation();
    });

    $('.custom-file-input').on('change', function () {
        let fileName = this.files[0].name;
        $(this).siblings('.custom-file-label').first().addClass("selected").html(fileName);
    });

});
